export class PaymentProvider {
  private _id: number;
  private _name: string;
  private _paymentName: string;
  private _showProviderName: boolean;
  private _disabled: boolean;
  extraPayAmount = 0;

  constructor(
    id: number,
    name: string,
    paymentName?: string,
    showProviderName?: boolean,
  ) {
    this._id = id;
    this._name = name;
    this._paymentName = paymentName || '';
    this._showProviderName = showProviderName;
  }

  get id(): number {
    return this._id;
  }

  get name(): string {
    return this._name;
  }

  get paymentName(): string {
    return this._paymentName;
  }

  get showProviderName(): boolean {
    return this._showProviderName;
  }

  get disabled(): boolean {
    return this._disabled;
  }

  set disabled(value: boolean) {
    this._disabled = value;
  }
}
